import { Box, Flex, FloraTypography, Tooltip } from '@grupoboticario/flora-react'
import { QuestionMarkCircleIcon } from '@grupoboticario/flora-react-icons'

import TagBox from '@/components/ExtractDetailsWithCashback/components/TagBox/TagBox'
import { formatCurrency } from '@/utils/format/formatCurrency'

import * as S from './TotalPointsDetails.styles'

const TotalPointsDetails = ({ totalPoint, totalCashback, totalLoyalty }) => {
  return (
    <Flex css={S.panelCss} gap="$6" justify="space-between">
      <Flex css={S.balanceCss} direction="column" gap="$2">
        <Flex gap="$2">
          <FloraTypography fontWeight="medium" fontSize="exceptionsAuxiliar">
            Saldo disponível
          </FloraTypography>
          <Tooltip
            align="start"
            autotagging-flora="off"
            direction="top"
            text="O saldo disponível é composto por pontos de Beautybox e Cashback."
          >
            <QuestionMarkCircleIcon size={14} />
          </Tooltip>
        </Flex>
        <FloraTypography as="h6" css={S.emphasisTextCss} fontSize="subtitle">
          {Number.parseInt(totalPoint.point).toLocaleString('pt-BR')} pontos
        </FloraTypography>
        <FloraTypography fontWeight="bold" fontSize="bodySmallStandard">
          {formatCurrency(totalPoint.value ?? 0)}
        </FloraTypography>
      </Flex>
      <Box css={S.dividerCss} />

      <TagBox points={totalLoyalty.point} theme="dark" title="Beautybox" value={totalLoyalty.value} />

      <TagBox points={totalCashback.point} theme="light" title="Cashback" value={totalCashback.value} />
    </Flex>
  )
}

export default TotalPointsDetails
